import { useParams, useLocation } from 'react-router'

import { WarehouseStockItemId } from 'app/common/types/id'
import { WarehouseTab } from 'app/common/types/warehouse/tabs'

import { Underconstruction } from '../Underconstruction'

export const masks = ['/:stockItemId']
export const section = 'movements'

export const createDishUrl = (dishId: WarehouseStockItemId, paths: Array<string>) =>
  paths[0].replace(':stockItemId', String(dishId))

export const WarehouseStockMovementsPage = (props: {
  baseUrl: string
  siblings: Array<{ section: string; baseUrl: string; otherUrls: Array<string> }>
}) => {
  const params = useParams()
  const location = useLocation()
  console.log({ params, location })
  return <Underconstruction tab={WarehouseTab.Movements} />
}
